// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__yJHZF","layout__mobile":"Layout_layout__mobile__k7+Xl","layout__content":"Layout_layout__content__qegCV"};